export interface ModalityDto {
  code: string;
  name: string;
}

export class ModalityLookup {
  public static readonly modalities: ModalityDto[] = [
    { code: 'CT', name: 'Tomograf' },
    { code: 'DM', name: 'Mammograf' },
    { code: 'DXA', name: 'Densytometria' },
    { code: 'MRI', name: 'Rezonans' },
    { code: 'RTG', name: 'Rentgen' },
    { code: 'USG', name: 'Usg' },
  ];
}
